import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useSiteContent } from "@/lib/useSiteContent";
import { keysFor } from "@/config/cmsSections";

export default function NotFound() {
    const c = useSiteContent(keysFor("not-found"));
    return (
        <div className="em-container py-32 text-center" data-testid="not-found-page">
            <p className="em-eyebrow">{c("notfound.eyebrow", "Erreur 404")}</p>
            <h1 className="font-display text-5xl md:text-7xl font-black tracking-tight text-primary mt-2">{c("notfound.title", "Page introuvable")}</h1>
            <p className="text-muted-foreground mt-4 max-w-md mx-auto">
                {c("notfound.body", "L'URL que vous cherchez n'existe pas (ou plus). Retournez à l'accueil ou utilisez le menu pour explorer le site.")}
            </p>
            <Button asChild className="rounded-full mt-8 bg-primary hover:bg-primary/90">
                <Link to="/">{c("notfound.cta", "Retour à l'accueil")}</Link>
            </Button>
        </div>
    );
}
